angular.module 'app'
.controller 'HotArticleCtrl', ($rootScope, $scope, $timeout, $http, $stateParams, $state, config, Storage, dialogs, growl) ->
  return $state.go 'app.wechat' if Storage.get('user_permission').monitor.article.is_use == false

  $scope.ui =
    isLoading: false
    totalItems: 0
    currentPage: 1
    perPage: 10
    maxSize: 6
    dataArr: []
    activeDataArr: []
    activeSort: ''
    region: ''
    date:
      startDate: moment().subtract(6, 'days')
      endDate: moment()
    opts: config.opts

  # 設置日曆
  $scope.ui.opts.parentEl = 'div#hot-article-monitor'
  $scope.ui.opts.opens = 'right'
  $scope.ui.opts.eventHandlers =
    'apply.daterangepicker': (ev, picker) ->
      growl.error '時間範圍不能超過七天' if $scope.ui.date.endDate.format('YYYY-MM-DD') > moment($scope.ui.date.startDate).add(6, 'days').format('YYYY-MM-DD')
      $scope.ui.date =
        startDate: moment($scope.ui.date.startDate)
        endDate: moment($scope.ui.date.startDate).add(6, 'days')

  $scope.findData = ->
    if $scope.ui.date.startDate is null or $scope.ui.date.endDate is null or String(new Date($scope.ui.date.startDate)) is 'Invalid Date' or String(new Date($scope.ui.date.endDate)) is 'Invalid Date'
      $scope.ui.date =
        startDate: moment().subtract(6, 'days')
        endDate: moment()
      growl.error('請輸入正確的時間')

    $scope.ui.isLoading = true
    $scope.ui.dataArr = []
    $scope.ui.activeDataArr = []
    $scope.ui.totalItems = 0
    $http.get "#{config.api.baseUrl}/monitor/ranking/article?access_token=" + Storage.get('access_token'),
      params:
        region: $scope.ui.region
        start_date: moment($scope.ui.date.startDate).format('YYYY-MM-DD 00:00:00')
        end_date: moment($scope.ui.date.endDate).format('YYYY-MM-DD 23:59:59')
    .then (res) ->
      _.each res.data.data, (data) ->
        data.date = moment(data.date).format('YYYY-MM-DD HH:mm:ss')
        data.title = data.title.replace(/\&\#39\;/g, '\'')
      $scope.ui.dataArr = res.data.data
      $scope.ui.totalItems = res.data.count
      $scope.ui.isLoading = false
    .finally ->
      $scope.$watch 'ui.currentPage', (newData) ->
        return if $scope.ui.dataArr.length == 0
        $scope.ui.activeDataArr = $scope.ui.dataArr.slice((newData - 1) * $scope.ui.perPage, (newData - 1) * $scope.ui.perPage + $scope.ui.perPage)
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')
      $scope.ui.isLoading = false

  $scope.sort = (_name) ->
    return if $scope.ui.dataArr.length == 0
    $scope.ui.dataArr.sort (a, b) ->
      if $scope.ui.activeSort != _name
        return b.read_num - (a.read_num) if _name == 'read_num'
        return b.like_num - (a.like_num) if _name == 'like_num'
        return b.e_index - (a.e_index) if _name == 'e_index'
      else
        return a.read_num - (b.read_num) if _name == 'read_num'
        return a.like_num - (b.like_num) if _name == 'like_num'
        return a.e_index - (b.e_index) if _name == 'e_index'
    $scope.ui.activeDataArr = $scope.ui.dataArr.slice(($scope.ui.currentPage - 1) * $scope.ui.perPage, ($scope.ui.currentPage - 1) * $scope.ui.perPage + $scope.ui.perPage)
    if $scope.ui.activeSort != _name
      $scope.ui.activeSort = _name
    else
      $scope.ui.activeSort = ''

  prepare = (url) ->
    dialogs.wait '請稍後', '正在努力下載...'
    $timeout (->
      $rootScope.$broadcast 'dialogs.wait.complete'
    ), 1000

  success = (url) ->
    $rootScope.$broadcast 'dialogs.wait.complete'

  error = (response, url) ->
    dialogs.error '下載失敗!'

  $scope.download = ->
    return if $scope.ui.dataArr.length == 0
    $.fileDownload "#{config.api.baseUrl}/monitor/ranking/article?access_token=" + Storage.get('access_token'),
      httpMethod: 'POST'
      data:
        start_date: moment($scope.ui.date.startDate).format('YYYY-MM-DD 00:00:00')
        end_date: moment($scope.ui.date.endDate).format('YYYY-MM-DD 23:59:59')
      prepareCallback: prepare
      successCallback: success
      failCallback: error
    $rootScope.$broadcast 'dialogs.wait.complete'

  $scope.findData()


  # 按下 Enter 鍵查詢
  $scope.keyUp = (e) ->
    keycode = if window.event then e.keyCode else e.which
    if keycode == 13
      $scope.ui.totalItems = 0
      $scope.ui.activeDataArr = []
      $scope.ui.currentPage = 1
      $scope.findData()
